// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"915b43d8","608":"0cd918d8"}[chunkId] + ".chunk.js";
};